export default __webpack_public_path__ + "images/042a91e7d5c82c1ca8de828c3c485de1.png";